

 export default { 
    name : 'Pages',
    methods: {
      onClickLink (href, isExternal) {
        this.$emit('click-link', href, isExternal)
      },
    },
  }